import { useIgnoreDefaultApiErrors } from "@features/errors/hooks/use-ignore-default-api-errors";
import { useUnit } from "effector-react";

import { closeSession } from "@entities/session";
import { PasswordExpiredDialog } from "@shared/ui/molecules/password-expired-dialog";

import { usePasswordExpiredLabels } from "../hooks/use-password-expired-labels";
import { $isPasswordExpired, resetPasswordExpired } from "../model";

type Props = {
  onAuthorize: () => void;
  onResetPassword: () => void;
};

export const PasswordExpiredDialogConnector = ({
  onAuthorize,
  onResetPassword,
}: Props) => {
  const isOpen = useUnit($isPasswordExpired);
  const { cancelLabel, confirmLabel, description, title } =
    usePasswordExpiredLabels();

  useIgnoreDefaultApiErrors(["ErrPasswordExpired"]);

  const handleConfirm = () => {
    resetPasswordExpired();
    onResetPassword();
  };

  const handleCancel = () => {
    resetPasswordExpired();
    closeSession();
    onAuthorize();
  };

  return (
    <PasswordExpiredDialog
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel}
      description={description}
      title={title}
      isOpen={isOpen}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
};
